import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';

/**
 * Service de gestion des erreurs de l'application.
 */
@Injectable({
  providedIn: 'root',
})
export class ErrorService {
  inError = new Subject<boolean>();
  code: number;
  message: string;

  /**
   * Creates an instance of {@link ErrorService}.
   * @constructor
   *
   * @memberof ErrorService
   */
  constructor() {
    this.inError.next(false);
  }

  /**
   * Suppression de l'erreur.
   *
   * @memberof ErrorService
   */
  clear(): void {
    this.code = undefined;
    this.message = undefined;
    this.inError.next(false);
  }

  /**
   * Crée une nouvelle erreur.
   *
   * @param code Code de l'erreur
   * @param message Message de l'erreur
   * @memberof ErrorService
   */
  setError(code, message): void {
    this.code = code;
    this.message = message;
    this.inError.next(true);
  }

  /**
   * Retourne un observable de inError
   *
   * @return {*}  {Observable<boolean>}
   * @memberof ErrorService
   */
  subscribeError(): Observable<boolean> {
    return this.inError.asObservable();
  }

  /**
   * Retourne si il y a une erreur ou pas
   *
   * @return {*}  {boolean}
   * @memberof ErrorService
   */
  isInError(): boolean {
    return this.code && this.message ? true : false;
  }

  /**
   * Retourne le message de l'erreur.
   *
   * @return {*}  {string}
   * @memberof ErrorService
   */
  getMessage(): string {
    return this.message;
  }

  /**
   * Retourne le coed de l'erreur.
   *
   * @return {*}  {number}
   * @memberof ErrorService
   */
  getCode(): number {
    return this.code;
  }
}
